module.exports = __webpack_public_path__ + "static/media/menu4.74bd6bdb.jpeg";